export default "__VITE_ASSET__CVPwTZDn__"